import { IMG_1gEVGivzjCTlp341WvH1KC } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabOutdoor() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'PersonRunning',
      text: t('detail.camera-ai')
    },
    {
      icon: 'HeadsetPerson',
      text: t('detail.camera-agent-assessment')
    },
    {
      icon: 'Siren',
      text: t('detail.camera-agent-action')
    },
    {
      icon: 'PoliceCar',
      text: t('detail.camera-agent-dispatch')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.camera-agent-notification')
    }
  ] as const
  const disclaimers = [
    t('disclaimer.active-guard-required'),
    t('disclaimer.camera-agent-dispatch')
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_1gEVGivzjCTlp341WvH1KC}
      details={details}
      disclaimers={disclaimers}
    />
  )
}
